import { render, staticRenderFns } from "./kfi-request-submission.vue?vue&type=template&id=1f8b1a24&"
import script from "./kfi-request-submission.vue?vue&type=script&lang=js&"
export * from "./kfi-request-submission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports